import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Educativo",
  icon: "🧠",
  templates: [
    {
      title: "Explícalo de Forma Simple",
      content: `Explica el tema de [cómo las vacunas entrenan al sistema inmunológico] de manera clara y atractiva para los oyentes.
- Imagina que se lo explicas a [un adolescente curioso sin conocimientos de ciencia].
- Usa una analogía cercana: [compáralo con un simulacro de incendio — practicas para algo para estar listo cuando ocurra de verdad].
- Evita la jerga; cuando sea necesario un término técnico, defínelo inmediatamente en lenguaje sencillo.
- Escribe con un tono cálido y alentador que haga sentir inteligente al oyente, sin ser condescendiente.`
    },
    {
      title: "Voz en Off de Documental",
      content: `Escribe una narración de voz en off estilo documental.
- Tema: [la vida diaria de los vendedores de comida callejera en Bangkok].
- Enfoque: [el oficio, el orgullo y el conocimiento generacional detrás de platos que parecen simples pero tardan años en dominar].
- Tono: [respetuoso, vívido y sin prisa — deja que las escenas respiren].
- Incluye detalles sensoriales que ayuden al oyente a imaginar y sentir el ambiente: [el chisporroteo de un wok, la humedad del mercado matutino, los movimientos precisos de un vendedor que ha hecho esto diez mil veces].
- Escribe en tiempo presente para dar inmediatez.`
    },
    {
      title: "Meditación Guiada",
      content: `Escribe un guión de meditación guiada diseñado para ser escuchado.
- Objetivo: [liberar la tensión después de un largo día de trabajo y entrar suavemente en la noche].
- Guía al oyente a visualizar [un lago tranquilo al atardecer — luz cálida sobre el agua, una brisa suave, el sonido de pájaros lejanos acomodándose para la noche].
- Tono: [tranquilo, sin prisa y reconfortante].
- Duración hablada aproximada: [8 minutos].
- Usa abundantes pausas naturales (marcadas con "...") entre las instrucciones. Mantén las oraciones cortas y suaves. Evita cambios bruscos de energía.`
    }
  ]
};
